import { render } from "./GrowTogether.vue?vue&type=template&id=32a63cd6&scoped=true"
import script from "./GrowTogether.vue?vue&type=script&lang=js"
export * from "./GrowTogether.vue?vue&type=script&lang=js"

import "./GrowTogether.vue?vue&type=style&index=0&id=32a63cd6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32a63cd6"

export default script